import React, { Fragment, useState, useEffect, useRef } from 'react'
import { Button, Radio } from 'antd'
import { ArrowRightOutlined } from '@ant-design/icons';
import './style.css'
import axios from 'axios'
import { Link } from "react-router-dom";
import * as echarts from 'echarts';


let timer;

export default function ServicePage(props) {
    const { data } = props;
    // const [nowSelectService, setNowSelectService] = useState(data[0]);
    const [nowSelectServiceIndex, setNowSelectServiceIndex] = useState(0);
    const [yeardata, setYeardata] = useState(0);
    const [monthdata, setMonthdata] = useState(0);
    const [weekdata, setWeekdata] = useState(0);
    const [dataCount, setDataCount] = useState(0)
    const [deviceCount, setDeviceCount] = useState(0)
    const [value, setValue] = useState(1);
    const [sixData, setSixData] = useState({ '几何产品': 0, '大气产品': 0, '植被产品': 0, '水体产品': 0, '辐射产品': 0, '陆表产品': 0 })

    useEffect(() => {
        // setTime();
        // getChartData()
        getData()
    }, [])
    useEffect(() => {
        if (nowSelectServiceIndex === 1) {
            initChart()
        }
    }, [nowSelectServiceIndex, value])

    const getChartData = async (type = 1) => {
        let { data } = await axios.get(`http://caplos.aircas.ac.cn/gateway/api/interface/a?measureType=${type}`)
        console.log('cc', data)
        let listname = []
        let listyear = []
        let listmonth = []
        let listweek = []
        if (data.code === '200') {
            data.payload.typeDataCountList.map(value => {
                listyear.push({ name: value.name, value: value.num })
                listmonth.push({ name: value.name, value: value.yueNum })
                listweek.push({ name: value.name, value: value.zhouNum })
            })
            setYeardata(listyear)
            setMonthdata(listmonth)
            setWeekdata(listweek)
            setDataCount(data.payload.dataCount)
            setDeviceCount(data.payload.deviceCount)
        }
        console.log('cc', data)
    }

    const getData = async () => {
        await axios.get('/gateway/api/interface/b').then(res => {
            setSixData(res.data.payload)
        })
    }

    const setTime = (count = 0) => {
        timer = setInterval(() => {
            if (count !== serviceList.length - 1) {
                count = count + 1;
                setNowSelectServiceIndex(count)
            } else {
                count = 0;
                setNowSelectServiceIndex(0);
            }
        }, 5000);
    }

    const onChange = async (e) => {
        setValue(e.target.value);
        await getChartData(e.target.value)
    };
    const changeIndex = (index) => {
        setNowSelectServiceIndex(index);
        clearInterval(timer);
        timer = null;
        // setTime(index);
    }
    const serviceList = [...data];
    const lastIndex = serviceList.length - 1;
    const nowSelectService = serviceList[nowSelectServiceIndex];
    const initChart = () => {
        const myRef = document.getElementById('main')
        if (myRef) {
            let myChart = echarts.init(myRef);
            let option = {
                tooltip: {
                    trigger: 'item'
                },
                series: [
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: '50%',
                        data: yeardata,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };
            myChart.setOption(option);
        }
    }

    const handleNum = (num) => {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    const switchDom = () => {
        switch (nowSelectServiceIndex) {
            case 1: return (
                <div className='ServicePage_RightImgs_Block'>
                    <div className='ServicePage_RightImgs_Block_Title'>
                        <div className='ServicePage_RightImgs_Block_Title_LeftLine'></div>
                        <div className='ServicePage_RightImgs_Block_Title_Text'>真值数据采集总量</div>
                        <div className='ServicePage_RightImgs_Block_Title_RightLine'></div>
                    </div>
                    <div className='ServicePage_RightImgs_Block_Content'>
                        {
                            Object.keys(sixData).map((item, i) => {
                                return (
                                    <div key={i} className='ServicePage_RightImgs_Block_Content_Item'>
                                        <div className='ServicePage_RightImgs_Block_Content_Item_Title'>{item}</div>
                                        <div className='ServicePage_RightImgs_Block_Content_Item_Num'>{handleNum(sixData[item])}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            )
            case 0: return (
                <div className='ServicePage_RightImgs_Block ServicePage_RightImgs_Block_Img_wrap'>
                    <img src='images/HomePage/ServicePage/img5.png' className='ServicePage_RightImgs_Block_Img'></img>
                </div>
            )
            case 2: return (
                <div className='ServicePage_RightImgs_Block ServicePage_RightImgs_Block_Img_wrap_white'>
                    <img src='images/HomePage/ServicePage/img6.png' className='ServicePage_RightImgs_Block_Img'></img>
                </div>
            )
            case 3: return (
                <div className='ServicePage_RightImgs_Block ServicePage_RightImgs_Block_Img_wrap_white'>
                    <img src='images/HomePage/ServicePage/img7.png' className='ServicePage_RightImgs_Block_Img'></img>
                </div>
            )
        }
    }

    return (
        <div className='ServicePage'>
            <img className='ServicePage_BackgroundImg' src={"images/HomePage/ServicePage/2.png"} />
            <div className='ServicePageMain'>
                <div className='ServicePage_Left'>
                    <img className='ServicePage_Left_BackgroundImg' src={"images/HomePage/ServicePage/leftImg.png"} />
                    <div className='ServicePage_LeftMain'>
                        <div className='ServicePage_LeftTitle'>共性服务推荐</div>
                        <div className='ServicePage_LeftTitleBottom' />
                        <div className='ServicePage_LeftServiceList'>
                            {serviceList.map((service, index) => {
                                return (
                                    <Fragment>
                                        <div
                                            className={nowSelectService.title === service.title ? 'ServicePage_LeftServiceList_Title_Selected' : "ServicePage_LeftServiceList_Title"}
                                            onClick={() => changeIndex(index)}>
                                            <div className='ServicePage_LeftServiceList_TitlePoint' />
                                            <div className='ServicePage_LeftServiceList_TitleText'>{service.title}</div>
                                        </div>
                                        {lastIndex !== index ?
                                            <div className='ServicePage_LeftServiceList_TitleBorder' /> : null}
                                    </Fragment>
                                )
                            })}
                            <div className='ServicePage_LeftMoreButton'>
                                <Link to='/UserLogin'>
                                    <div className='ServicePage_LeftMore'>
                                        <div className='ServicePage_LeftMoreText'>更多</div>
                                        <img className='ServicePage_LeftMoreIcon'
                                            src='images/HomePage/FirstPage/more2.png' alt={""} style={{ width: '3.2rem', height: '3.2rem' }} />
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ServicePage_Right' onMouseEnter={() => clearInterval(timer)} onMouseLeave={() => changeIndex(nowSelectServiceIndex)}>
                    <div className='ServicePage_RightTitle'>
                        <div className='ServicePage_RightTitleSpan' />
                        <div className='ServicePage_RightTitleText'>{nowSelectService.title}</div>
                    </div>
                    <div className='ServicePage_RightIntroduce'>{nowSelectService.introduce}</div>
                    <div className='ServicePage_RightImgs'>
                        {
                            // nowSelectService.title === '真值数据采集与处理服务' ?
                            //     <>
                            //         <div className='numContainer'>
                            //             <span className='numText'>设备总类:{deviceCount}</span>
                            //             <span className='numText'>数据条目数:{dataCount}</span>
                            //             <Radio.Group onChange={onChange} value={value}>
                            //                 <Radio value={1}>手动</Radio>
                            //                 <Radio value={2}>自动</Radio>
                            //             </Radio.Group>
                            //         </div>
                            //         <div className='ServicePage_RightImg' id='main' />
                            //     </>
                            //     : <img className='ServicePage_RightImg' src={nowSelectService.img} />
                            switchDom()
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}